var map = {
	"./android-chrome-192x192.png": 23,
	"./android-chrome-512x512.png": 5327,
	"./apple-touch-icon.png": 1776,
	"./browserconfig.xml": 9076,
	"./favicon-16x16.png": 1359,
	"./favicon-32x32.png": 5015,
	"./favicon.ico": 670,
	"./favicon.png": 8258,
	"./favicon.svg": 2351,
	"./mstile-144x144.png": 9183,
	"./mstile-150x150.png": 4795,
	"./mstile-310x150.png": 9477,
	"./mstile-310x310.png": 1247,
	"./mstile-70x70.png": 129,
	"./safari-pinned-tab.svg": 9406,
	"./site.webmanifest": 2115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8817;